module.exports = __webpack_public_path__ + "img/0d2d0bb.jpg";